const statBlock = {
  displayField: 'title',
  name: 'Stat Block',
  description: 'Stat data',
  fields: [
    {
      id: 'title',
      name: 'Title',
      type: 'Symbol',
      localized: false,
      required: true,
      validations: [],
      defaultValue: { 'en-US': 'Stat Block' },
      disabled: false,
      omitted: false
    },
    {
      id: 'select',
      name: 'Select',
      type: 'Array',
      localized: false,
      required: true,
      validations: [ { size: { min: 2, max: 4 } } ],
      disabled: false,
      omitted: false,
      items: {
        type: 'Symbol',
        validations: [
          {
            in: [
              'No Of Advisors Worldwide',
              'No Of Advisors Americas',
              'No Of Professionals Americas',
              'No Of Professionals Americas Except HQ And MLP',
              'No Of Affiliations Americas',
              'No Of Shops Globally',
              'No Of Shops Americas',
              'No Of Shops UnitedStates',
              'No Of Shops Canada',
              'No Of Americas Shops Outside Canad And US',
              'No Of Countries Engel VolkersIsIn',
              'No Of Continents'
            ]
          }
        ]
      }
    }
  ],
  sys: {
    id: 'statBlock',
    version: 44,
    updatedAt: '2023-05-31T06:22:13.599Z'
  }
};
export default statBlock;